module.exports = __webpack_public_path__ + "static/media/Red-whiskered bulbul template.009a671f.wav";